import { useCallback } from 'react'
import { numericComparer } from '../../../helpers/numericComparer'
import { useConfigValueByCurrentDevice } from '../../../../hooks/useConfigValueByCurrentDevice'
import { config } from '../../../../components/Init/Init'
import { usePlayerStore } from '../../../store/playerStore'

export const useNewJackpotsGameIds = () => {
  const enableDiamondJackpotOverlays = useConfigValueByCurrentDevice(config.enableDiamondJackpotOverlays)
  const playerStore = usePlayerStore()
  const playerActiveCurrencyData = playerStore.use.playerActiveCurrencyData()

  const isJackpotDiamondAndSupportsCurrentCurrency = useCallback(
    jackpot => {
      const isDiamondJackpot =
        jackpot.currency === 'DIA' &&
        jackpot.supportedCurrencies &&
        jackpot.supportedCurrencies.includes(playerActiveCurrencyData.currencyName)

      return config.showGrandDiamondJackpotOverlaysOnly
        ? jackpot.level === config.grandJackpotLevel && isDiamondJackpot
        : isDiamondJackpot
    },
    [playerActiveCurrencyData.currencyName]
  )

  const getNewJackpotsGameIds = useCallback(
    jackpots => {
      const newJackpotGameIds = jackpots
        .filter(
          jackpot =>
            (isJackpotDiamondAndSupportsCurrentCurrency(jackpot) && enableDiamondJackpotOverlays) ||
            (config.showGrandJackpotOverlaysOnly
              ? jackpot.currency === playerActiveCurrencyData.currencyName && jackpot.level === config.grandJackpotLevel
              : jackpot.currency === playerActiveCurrencyData.currencyName)
        )
        .map(jp => jp.gameIds)
        .flat()

      const singleEntryNewJackpotGameIds = newJackpotGameIds.filter(
        (item, index) => newJackpotGameIds.indexOf(item) === index
      )

      return singleEntryNewJackpotGameIds.sort(numericComparer)
    },
    [isJackpotDiamondAndSupportsCurrentCurrency, playerActiveCurrencyData.currencyName]
  )

  return { getNewJackpotsGameIds }
}
